import { Trans } from '@lingui/react/macro';
import { useDateFormat } from '@web/services/locale';
import { useTheme } from '@web/styles/theme/hooks';
import Box from 'carbon-react/lib/components/box';
import { Table, TableBody, TableHead, TableHeader, TableRow } from 'carbon-react/lib/components/table';
import { useId } from 'react';
import styled from 'styled-components';
import { TimesheetBulkDeleteItem } from '../TimesheetModalContext';
import { TimesheetListItem } from './TimesheetListItem';

const Root = styled.div`
  display: flex;
  flex-direction: column;
`;

export interface TimesheetsListProps {
  timesheets: TimesheetBulkDeleteItem[];
}

export const TimesheetsList = ({ timesheets }: TimesheetsListProps) => {
  const tableId = useId();
  const dateFormat = useDateFormat();
  const theme = useTheme();
  return (
    <Root>
      <Table variant="subtle-white">
        <TableHead>
          <TableRow id={`${tableId}-row-1`}>
            <TableHeader width={`${theme.spacing * 15}px`}>
              <Box justifyContent="space-between" alignItems="center" display="flex">
                <Trans>Begin date</Trans>
              </Box>
            </TableHeader>
            <TableHeader width={`${theme.spacing * 15}px`}>
              <Box justifyContent="space-between" alignItems="center" display="flex">
                <Trans>End date</Trans>
              </Box>
            </TableHeader>
            <TableHeader>
              <Box justifyContent="space-between" alignItems="center" display="flex">
                <Trans>Description</Trans>
              </Box>
            </TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {timesheets.map((timesheet) => (
            <TimesheetListItem key={timesheet.id} timesheet={timesheet} dateFormat={dateFormat} />
          ))}
        </TableBody>
      </Table>
    </Root>
  );
};
